(() => {
 class OnaMeasurementFilm extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController(); const {signal} = this.controller;
   this.video = this.querySelector('video'); this.button = this.querySelector('[data-guide-play]');
   this.button.addEventListener('click', () => {
    // Load only in direct response to the viewer. Hidden guide instances do not fetch video.
    if (!this.video.getAttribute('src')) {
     this.video.controls = true; this.video.src = this.video.dataset.guideSrc;
     if (this.video.dataset.guideVtt) {const track=document.createElement('track');track.kind='captions';track.srclang='en';track.label='English';track.src=this.video.dataset.guideVtt;this.video.append(track);}
     this.video.load();
    }
    this.video.play().then(()=>{this.button.hidden=true;this.video.focus();}).catch(()=>{this.button.textContent='Play the measuring guide';});
   }, {signal});
   this.video.addEventListener('play',()=>{document.querySelectorAll('ona-measurement-film video').forEach(other=>{if(other!==this.video)other.pause();});},{signal});
   this.video.addEventListener('error',()=>{this.button.hidden=false;this.button.textContent='Video unavailable — read the transcript below';this.button.disabled=true;}, {signal});
   this.video.addEventListener('ended',()=>{this.button.hidden=false;this.button.textContent='Watch again';}, {signal});
   this.closest('dialog')?.addEventListener('close',()=>this.video.pause(),{signal});
   document.addEventListener('visibilitychange',()=>{if(document.hidden)this.video.pause();},{signal});
   window.addEventListener('pagehide',()=>this.video.pause(),{signal});
   this.observer=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)this.video.pause();},{threshold:0});this.observer.observe(this.video);
  }
  disconnectedCallback(){this.video?.pause();this.controller?.abort();this.observer?.disconnect();this.controller=null;}
 }
 if(!customElements.get('ona-measurement-film'))customElements.define('ona-measurement-film',OnaMeasurementFilm);
})();
